import { Card } from '../../common';
import { Header } from './comonents';
import { IAuthLayoutProps } from './types';

export const Layout = ({ title, children }: IAuthLayoutProps) => (
  <div className="h-full bg-background-base-alt">
    <Header />
    <div className="min-h-[calc(100%-65px)] w-full overflow-auto pt-[65px] bg-background-base-alt flex items-center justify-center">
      <Card className="w-full max-w-[410px] border border-solid border-border-light">
        <h3 className="typography-heading-large text-text-primary">{title}</h3>
        {children}
      </Card>
    </div>
  </div>
);
